import { createContext } from 'react';

const RequiredFieldsContext = createContext({});

export default RequiredFieldsContext;
